import { render } from "./StudentView.vue?vue&type=template&id=10611a81&scoped=true&ts=true"
import script from "./StudentView.vue?vue&type=script&lang=ts"
export * from "./StudentView.vue?vue&type=script&lang=ts"

import "./StudentView.vue?vue&type=style&index=0&id=10611a81&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10611a81"]])

export default __exports__